import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-b-small', 'LetterBSmall', [["path",{"d":"M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8"}]]);